const __WEBPACK_NAMESPACE_OBJECT__ = require("@grafana/faro-web-sdk");